<cc-version-update-notifier
    [currentVersion]="currentVersion"
    [latestVersion]="latestVersion"
    [durationInMin]="durationBeforeMandatoryRefreshMinutes"
/>
<cc-tooltip></cc-tooltip>
<cc-modal-layer></cc-modal-layer>
<cc-nav-bar [clientCode]="clientCode" [appDisplayName]="appDisplayName" [versions]="versions"></cc-nav-bar>

<div>
    <router-outlet></router-outlet>
</div>

<div class="loader-parent" *ngIf="isLoading">
    <div class="spinner loader">
        <div class="blue-spinner"></div>
        <div class="gray-spinner"></div>
    </div>
</div>

<app-alert [clientCode]="clientCode" [autoDismissErrors]="autoDismissErrors"></app-alert>
